export default "__VITE_ASSET__B_C691NJ__"